import {Directive, ElementRef, OnDestroy, OnInit} from "@angular/core";
import {TooltipService} from "@components/tooltip/tooltip.service";

@Directive({
  standalone: true,
  selector: '[appTooltipElement]',
})
export class TooltipElementDirective implements OnInit, OnDestroy {

  private resizeObserver: ResizeObserver;

  constructor(
    private el: ElementRef,
    private tooltipService: TooltipService) {
  }

  ngOnInit() {
    this.elementObserver();
  }

  ngOnDestroy() {
    this.resizeObserver.unobserve(this.el.nativeElement);
  }

  elementObserver() {
    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const contentRect = entry.contentRect;
        this.tooltipService.setTooltipHeight(contentRect.height + contentRect.top * 2);
        this.tooltipService.setTooltipWidth(contentRect.width + contentRect.left * 2);
      }
    });
    this.resizeObserver.observe(this.el.nativeElement);
  }
}
